import { cn } from "@/utils/cn";
import type { ReactNode } from "react";

interface ActionButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode;
}

export const ActionButton = ({
  label,
  onClick,
  disabled = false,
  children,
}: ActionButtonProps) => (
  <div className="relative group/tip">
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "flex items-center gap-1 rounded px-1.5 py-0.5 text-2xs transition-colors",
        "text-gray-400 hover:text-gray-600",
        "bg-transparent hover:bg-gray-100 disabled:bg-transparent",
        "cursor-pointer disabled:cursor-default disabled:opacity-50",
      )}
    >
      {children}
    </button>
    <span
      aria-hidden
      className="pointer-events-none absolute bottom-full left-1/2 mb-1 -translate-x-1/2 whitespace-nowrap rounded bg-gray-800 px-2 py-0.5 text-3xs text-white opacity-0 transition-opacity group-hover/tip:opacity-100"
    >
      {label}
    </span>
  </div>
);
